<ng-container *ngIf="isOpen$ | async">
  <button
    type="button"
    class="cart-drawer__overlay"
    aria-label="Close cart"
    (click)="close()"
  ></button>

  <aside
    class="cart-drawer__panel"
    role="dialog"
    aria-label="Shopping cart"
    (mouseenter)="cancelAutoClose()"
    (touchstart)="cancelAutoClose()"
  >
    <header class="cart-drawer__header">
      <h2 class="cart-drawer__title">Your Cart</h2>
      <button
        type="button"
        class="cart-drawer__close"
        aria-label="Close"
        (click)="close()"
      >
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </header>

    <nav *ngIf="showNativeTab && showExclusivesTab" class="cart-drawer__tabs" role="tablist">
      <button
        type="button"
        role="tab"
        class="cart-drawer__tab"
        [class.is-active]="(activeTab$ | async) === 'native'"
        [attr.aria-selected]="(activeTab$ | async) === 'native'"
        (click)="selectTab('native')"
      >
        Russell's
        <span class="cart-drawer__tab-count">({{ nativeCount$ | async }})</span>
      </button>
      <button
        type="button"
        role="tab"
        class="cart-drawer__tab"
        [class.is-active]="(activeTab$ | async) === 'exclusives'"
        [attr.aria-selected]="(activeTab$ | async) === 'exclusives'"
        (click)="selectTab('exclusives')"
      >
        Online Exclusives
        <span class="cart-drawer__tab-count">({{ exclusivesCount$ | async }})</span>
      </button>
    </nav>

    <section class="cart-drawer__body">
      <app-native-tab
        *ngIf="showNativeTab && (!showExclusivesTab || (activeTab$ | async) === 'native')"
      ></app-native-tab>
      <app-exclusives-tab
        *ngIf="showExclusivesTab && (!showNativeTab || (activeTab$ | async) === 'exclusives')"
      ></app-exclusives-tab>
    </section>
  </aside>
</ng-container>
